import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import FormTitle from '@src/mobile/phtvHostSurvey2024/layout/Component/FormTitle';
import FormInput from '@src/mobile/phtvHostSurvey2024/layout/Component/FormInput';
import FormTextarea from '@src/mobile/phtvHostSurvey2024/layout/Component/FormTextarea';
import UploadVideo from '../Media/UploadVideo';

const Needlessly = ({
    formData,
    setFormDataHandle,
    warningTextList,
    updateSuccess
}) => {
    const [isUnfold, setUnfold] = useState(false);

    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    const unflodHandle = () => {
        setUnfold(!isUnfold);
    };

    return (
        <div className={styles.needlessly}>
            <div className={styles.needlesslyHead}>
                <div className={styles.needlesslyTitle}>選填信息</div>
                <div className={`${styles.needlesslyChange} ${isUnfold ? styles.active : ''}`} onClick={unflodHandle}>
                    <img className={styles.needlesslyPic1} src="https://x0.ifengimg.com/ucms/2024_28/86E3DF5D8CCF9974E82AB32E7023D51221C9A7E6_size6_w204_h60.png" />
                    <img className={styles.needlesslyPic2} src="https://x0.ifengimg.com/ucms/2024_28/3DB90441D54DE7773524F0DECEC9FB51C4A97DD9_size6_w204_h60.png" />
                </div>
            </div>
            <div className={styles.needlesslyInfo}>
                更豐富的自我介紹，能讓我們更快速地了解你，以及快速地決定是否聯繫你。
            </div>
            <div style={{ display: isUnfold ? 'block' : 'none' }} className={styles.formNeedlesslyList}>
                <div className={styles.formListBox}>
                <FormTitle name="video_production" title="視頻作品" warningText={warningTextList['video_production']} />
                    <div className={styles.picInfo}>選填資料可於必填資料提交之後再填寫<br />請上傳本人出鏡、不使用美顏、不使用濾鏡、不配樂、帶環境、有主題、動態為主的視頻，3分鐘內<br />視頻僅支持mp4、mov、quicktime格式</div>
                    <UploadVideo name="video_production" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle name="nationality" title="國籍" warningText={warningTextList['nationality']} />
                    <FormInput name="nationality" formData={formData} placeholder="" changeInputHandle={changeInputHandle} />
                    <FormTitle title="擅長語種" name="language" warningText={warningTextList['language']} />
                    <FormInput name="language" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle
                        title="介紹一下自己"
                        name="self_introduction"
                        warningText={warningTextList['self_introduction']}
                    />
                    <FormTextarea
                        limitWord={1000}
                        formData={formData}
                        placeholder="性格特點、參與活動經歷、獲獎情況及特長等"
                        name="self_introduction"
                        changeInputHandle={changeInputHandle}
                        updateSuccess={updateSuccess}
                    />
                    <FormTitle
                        title="還能在哪些平台了解你"
                        name="other_platforms"
                        warningText={warningTextList['other_platforms']}
                    />
                    <FormTextarea
                        limitWord={300}
                        formData={formData}
                        placeholder="請列舉社交平台名稱及個人賬號名等信息"
                        name="other_platforms"
                        changeInputHandle={changeInputHandle}
                        updateSuccess={updateSuccess}
                    />
                </div>
            </div>
        </div>
    );
};

Needlessly.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
    updateSuccess: PropTypes.bool,
};

export default errorBoundary(Needlessly);
